var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTimeRequests = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 17.5H4.1665",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L6.33333 12.75C5.49398 13.3795 5 14.3675 5 15.4167V16.6667C5 17.1269 5.3731 17.5 5.83333 17.5H14.1667C14.6269 17.5 15 17.1269 15 16.6667V15.4167C15 14.3675 14.506 13.3795 13.6667 12.75L10 10",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 2.50004H15.8332",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L13.6667 7.25C14.506 6.62049 15 5.63252 15 4.58333V3.33333C15 2.8731 14.6269 2.5 14.1667 2.5H5.83333C5.3731 2.5 5 2.8731 5 3.33333V4.58333C5 5.63252 5.49398 6.62049 6.33333 7.25L10 10",
    stroke: "#2F80ED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimeRequests, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/timeRequests.18e4f53a.svg";
export { ForwardRef as ReactComponent };